module.exports = __webpack_public_path__ + "static/media/YF99_3.31a97945.jpg";